import { TableCampaign } from "./CampaignConfig/Campaign/Table/TableCampaign";

export const PageCampaign = () => {
  return (
    <>
      {/* <Grid container spacing={4}>
        <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
          <CardCore
            sx={{ margin: "0 0 22px 0", padding: "12px", height: "130px" }}
          >
            Banner 1
          </CardCore>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <CardCore
            sx={{ margin: "0 0 22px 0", padding: "12px", height: "130px" }}
          >
            Banner 2
          </CardCore>
        </Grid>
      </Grid> */}

      <TableCampaign />
    </>
  );
};
